import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { singlePointValuesModalActions } from '../../../../redux/profiles/patientHealthboard/single-point-values-modal';
import {
  selectEntitySinglePointValuesModal,
  selectMetricSettingsSinglePointValuesModal,
  selectMonthTitleSinglePointValuesModal,
  selectOpenedSinglePointValuesModal,
  selectTypeSinglePointValuesModal,
  selectValueSinglePointValuesModal,
} from '../../../../redux/profiles/patientHealthboard/selectors';

const mapStateToProps = state => ({
  openedSinglePointValueModal: selectOpenedSinglePointValuesModal(state),
  dataType: selectTypeSinglePointValuesModal(state),
  month: selectMonthTitleSinglePointValuesModal(state),
  entity: selectEntitySinglePointValuesModal(state),
  value: selectValueSinglePointValuesModal(state),
  metricSettings: selectMetricSettingsSinglePointValuesModal(state),
});

const mapDispatchToProps = {
  close: singlePointValuesModalActions.close,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/SinglePointValueModal/enhance.js